import Purchase from "../../../orders/Purchase";
import { LessonDataI } from "../../../quiz/typesAndEnums";

const LessonExpired = ({ lessonData }: { lessonData: LessonDataI }) => {
  return (
    <>
      <div
        role="alert"
        className="my-5 w-full rounded-lg bg-slate-50 border border-slate-300 text-slate-600 px-4 py-3 flex flex-row-reverse"
      >
        إنتهت صلاحية الحصة ، يمكنك شراء الحصة مجدداً
      </div>
      <Purchase lessonData={lessonData} isRepurchase={true} />
    </>
  );
};

export default LessonExpired;
